// Public entry — bundled as window.BF (IIFE).
//
// Theming is *not* part of the JS layer. The host page is expected to drive
// the [data-bf-theme] and [data-bf-primary] attributes via server rendering
// (htmx) plus light client state (Alpine). See docs/theming.md for the
// recommended pattern.
//
// Convention: every JS module exposes init(root?) for delegated auto-wiring,
// plus imperative helpers (open/close/toggle/etc.) for programmatic control.

import * as tooltip from './tooltip';
import * as dropdown from './dropdown';
import * as modal from './modal';
import * as drawer from './drawer';
import * as tabs from './tabs';
import * as toast from './toast';
import * as shell from './shell';
import * as combobox from './combobox';
import * as alert from './alert';
import { ready } from './util';

export { tooltip, dropdown, modal, drawer, tabs, toast, shell, combobox, alert };

export const version = '0.1.0';

export function init(root: ParentNode = document): void {
  shell.init(root);
  tooltip.init(root);
  dropdown.init(root);
  dropdown.bindGlobals();
  modal.init(root);
  drawer.init(root);
  tabs.init(root);
  combobox.init(root);
  toast.init(root);
  alert.init(root);
}

// Auto-init on DOMContentLoaded, with an opt-out attribute on <html>.
ready(() => {
  if (document.documentElement.dataset.bfAutoInit === 'false') return;
  init(document);
});
